<template>
  <div>
    <el-alert title="点击单元格即可添加课程" type="warning" effect="dark" show-icon :closable="true" />
    <!-- 数据表格 -->
    <ele-data-table ref="table" :config="table" height="calc(100vh - 261px)" @cell-click="openAdd" highlight-current-row style="margin-top: 20px">
      <el-table-column align="center" label="节次＼时间" prop="section">
        <templeta slot-scope="{ row }">
          <div>{{ '第' + row.section + '节次' }}</div>
          <div>{{ row.beginTime + '-' + row.endTime }}</div>
        </templeta>
      </el-table-column>
      <el-table-column align="center" label="星期一">
        <templeta slot-scope="{ row }">
          <div>{{ row.week1.couseName }}</div>
        </templeta>
      </el-table-column>
      <el-table-column align="center" label="星期二">
        <templeta slot-scope="{ row }">
          <div>{{ row.week2.couseName }}</div>
        </templeta>
      </el-table-column>
      <el-table-column align="center" label="星期三">
        <templeta slot-scope="{ row }">
          <div>{{ row.week3.couseName }}</div>
        </templeta>
      </el-table-column>
      <el-table-column align="center" label="星期四">
        <templeta slot-scope="{ row }">
          <div>{{ row.week4.couseName }}</div>
        </templeta>
      </el-table-column>
      <el-table-column align="center" label="星期五">
        <templeta slot-scope="{ row }">
          <div>{{ row.week5.couseName }}</div>
        </templeta>
      </el-table-column>
      <el-table-column align="center" label="星期六">
        <templeta slot-scope="{ row }">
          <div>{{ row.week6.couseName }}</div>
        </templeta>
      </el-table-column>
      <el-table-column align="center" label="星期日">
        <templeta slot-scope="{ row }">
          <div>{{ row.week7.couseName }}</div>
        </templeta>
      </el-table-column>
    </ele-data-table>
    <!--添加课程弹窗-->
    <el-dialog
      title="设置课程"
      :visible.sync="showEdit"
      width="30%"
      @closed="editForm = { courseName: '' }"
      :destroy-on-close="true"
      custom-class="ele-dialog-form"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="85px" @keyup.enter.native="save(editForm.id)" @submit.native.prevent>
        <el-form-item label="课程:" prop="courseName">
          <el-input v-model="editForm.courseName" placeholder="请输入课程名称" clearable :autofocus="true" />
        </el-form-item>
        <el-form-item label="任课教师:">
          <treeselect
            v-model="editForm.teacherId"
            :options="teacherList"
            :disable-branch-nodes="true"
            placeholder="请选择所属任课教师"
            :defaultExpandLevel="4"
            :normalizer="
              (d) => {
                return { id: d.id, label: d.name };
              }
            "
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false">取 消</el-button>
        <el-button type="primary" @click="save(editForm.id)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'; // 下拉树
  import '@riophae/vue-treeselect/dist/vue-treeselect.css';
  import { addCourse, getAllDepartTeachers, updateCourse } from '@/config/api';

  export default {
    name: 'CourseList',
    components: { Treeselect },
    data() {
      return {
        table: {
          // 表格配置
          url: '/course/getCourseListByClass',
          where: {},
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        editForm: {
          courseName: '',
        },
        editRules: {
          courseName: [{ required: true, message: '请输入课程名称', trigger: 'blur' }],
        },
        classId: '',
        showEdit: false,
        teacherList: [],
      };
    },
    methods: {
      // 打开弹窗
      openAdd(row, column) {
        if (!this.classId) return this.$message.error('请选择班级再设置课程');
        this.queryDept();
        this.editForm.sectionId = row.sectionId;
        if (column.label === '星期一') {
          this.editForm.week = 1;
          this.editForm.id = row.week1.id;
          this.editForm.teacherId = row.week1.teacherId;
          this.editForm.courseName = row.week1.couseName;
          this.showEdit = true;
        } else if (column.label === '星期二') {
          this.editForm.week = 2;
          this.editForm.id = row.week2.id;
          this.editForm.teacherId = row.week2.teacherId;
          this.editForm.courseName = row.week2.couseName;
          this.showEdit = true;
        } else if (column.label === '星期三') {
          this.editForm.week = 3;
          this.editForm.id = row.week3.id;
          this.editForm.teacherId = row.week3.teacherId;
          this.editForm.courseName = row.week3.couseName;
          this.showEdit = true;
        } else if (column.label === '星期四') {
          this.editForm.week = 4;
          this.editForm.id = row.week4.id;
          this.editForm.teacherId = row.week4.teacherId;
          this.editForm.courseName = row.week4.couseName;
          this.showEdit = true;
        } else if (column.label === '星期五') {
          this.editForm.week = 5;
          this.editForm.id = row.week5.id;
          this.editForm.teacherId = row.week5.teacherId;
          this.editForm.courseName = row.week5.couseName;
          this.showEdit = true;
        } else if (column.label === '星期六') {
          this.editForm.week = 6;
          this.editForm.id = row.week6.id;
          this.editForm.teacherId = row.week6.teacherId;
          this.editForm.courseName = row.week6.couseName;
          this.showEdit = true;
        } else if (column.label === '星期日') {
          this.editForm.week = 7;
          this.editForm.id = row.week7.id;
          this.editForm.teacherId = row.week7.teacherId;
          this.editForm.courseName = row.week7.couseName;
          this.showEdit = true;
        } else {
          this.showEdit = false;
        }
      },
      // 获取部门老师树
      queryDept() {
        getAllDepartTeachers().then((res) => {
          if (res.data.resCode == 200) {
            this.teacherList = this.$util.toTreeData(res.data.data, 'id', 'parentId');
            this.deleteChildren(this.teacherList);
            this.getRoleTreeRootNode(this.teacherList[0].id);
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 循环数组 children为空时删除 且部系年级下无children时禁用
      deleteChildren(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children) {
            if (data[i].children.length) {
              this.deleteChildren(data[i].children);
            } else {
              data[i].disabled = true;
              if (data[i].type !== 2) {
                delete data[i].children;
              }
            }
          }
        }
        return data;
      },
      // 获取树形结构默认展开节点
      getRoleTreeRootNode(provincialCenterId) {
        this.teacherListNode.push(provincialCenterId);
      },
      save(id) {
        if (id === '') {
          let formData = new FormData();
          for (let key in this.editForm) {
            if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
              formData.append(key, this.editForm[key]);
            }
          }
          formData.append('classId', this.classId);
          addCourse(formData).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            }
          });
        } else {
          let formData = new FormData();
          formData.append('id', this.editForm.id);
          formData.append('courseName', this.editForm.courseName);
          formData.append('teacherId', this.editForm.teacherId);
          updateCourse(formData).then((res) => {
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            }
          });
        }
        this.showEdit = false;
      },
    },
  };
</script>

<style scoped>
  .el-alert--warning.is-dark {
    color: rgb(25, 137, 250);
    background: rgb(236, 249, 255);
  }
  .el-alert.is-dark .el-alert__closebtn {
    color: #1a1a1a;
  }
</style>
